/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable prefer-object-spread */
/* eslint-disable import/no-cycle */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-danger */
/* eslint-disable indent */
import React, { useState, useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import $ from 'jquery';
// import CryptoJS from 'crypto-js';
import { Rnd } from 'react-rnd';
import { Box, MenuItem, Select, Modal, Stack, Grid, Button, Tooltip, Checkbox, ToggleButton, ToggleButtonGroup } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import { ExecuteContext } from '../Flow';
import { closeIconBlack, feed_water, feed_tea, note, silica_3s, silica_7s } from '../../shared/assets/images';
import { defaultModalOptions, defaultUnitValues } from '../../shared/constantVariable';
import Notification from '../../shared/notification-modal';
import { saveFormDataInLocalStorage } from '../../shared/feed-common-feature';
import './edi.scss';
import UIGrid from '../uigrid';
import { convertUnitValues_flow, convertUnitValues_pressure } from '../../shared/conversion-helper/unitConversion';
import { output_data } from './output_data';
import { getBorderColor } from '../../shared/utils';
// import { getEDIDataOnChange } from '../../shared/api/url-helper';
import EDISchematicView from './edi-schematic-view';

// let currentSelectedEDI = '';
let output_dataCopy = JSON.parse(JSON.stringify(output_data));
// keep the original output data using JSON.parse(JSON.stringify(output_data));
const originalOutputData = JSON.parse(JSON.stringify(output_data));
const checkboxprop = { inputProps: { 'aria-label': 'Checkbox demo' } };

// let changeEDIFormDataFlag = false;

const EDIInput = (props) => {
  const { visibleEDI, handleCloseEDI, ediDetails, dbTransactionDetails, inputOutputFlag, setInputOutputFlag, translateObject, setokbuttonFormAutoSave } = props;
  // const executeEdiData = useContext(ExecuteContext);
  const [defaultCheck, setDefaultCheck] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [stackModel, setStackModel] = useState('');
  const [targetsilica, setTargetSilica] = useState('');
  const [selectedRecovery, setSelectedRecovery] = useState(0);
  const [dcoutput, setDCOutput] = useState(0);
  const [disabled, setDisabled] = useState(true);
  const [inputDisabled] = useState(true);
  const [silicaDisable, setSilicaDisabled] = useState(true);
  const [stackModels, setStackModels] = useState([]);
  const targetSilicas = [5, 10, 20];
  const [target_resistivity, setTargetResistivity] = useState(0);
  const [flow_per_stack, setFlowPerStack] = useState(0);
  const [flowRange, setFlowRange] = useState({ min: 0, max: 100 });
  const [upstream_pip, setUstreamPip] = useState(0.680); // pressure default units atm
  const [rectifier_efficiency, setRectifierEfficiency] = useState(70);
  const [roEDIModelName, setRoEDIModelName] = useState('');
  const [activeform, setActiveForm] = useState('design');
  const [units, setUnits] = useState(defaultUnitValues);
  const [downloadUrl, setDownloadUrl] = useState('');
  const [resRange, setResRange] = useState({ min: 0, max: 100 });

  const [validaterectEff, setValidateRectEff] = useState(false);
  const [validateflow, setValidateFlow] = useState(false);
  const [targetres, setTargetres] = useState(false);
  const [ustreamRes, setUstreamRes] = useState(false);
  const [explolimitH2, setExploLimitH2] = useState(4);
  const [safefactH2, setSafeFactH2] = useState(25);
  const [expolimitCl2, setExpoLimitCl2] = useState(0.00005);
  const [safefactCl2, setSafeFactCl2] = useState(100);
  const [showimg, setShowImg] = useState(feed_water);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [visibleEDISchematic, setVisibleEDISchematic] = useState(false);
  const [cocurrent, setCoCurrent] = useState(false);
  const [recoveryOptions, setRecoveryOptions] = useState([]);
  const [isRecoveryDisabled, setIsRecoveryDisabled] = useState(true);

  const [system_params, setsystem_params] = useState([...output_dataCopy.system_param]);
  const [feed_water_params, setfeed_water_params] = useState([...output_dataCopy.feed_param]);
  const [calculated_params, setcalculated_params] = useState([...output_dataCopy.calc_param]);
  const [elec_gas_gen, setelec_gas_gen] = useState([...output_dataCopy.electrode_gas_gen]);
  const [sizing_h2, setsizing_h2] = useState([...output_dataCopy.sizing_for_h2]);
  const [sizing_cl2, setsizing_cl2] = useState([...output_dataCopy.sizing_for_cl2]);
  const elec_gas_gen_props = [
    { hdata: translateObject('Gas'), tag: 'gas', datatype: 'text', disabled: true },
    { hdata: translateObject('Units'), tag: 'units', datatype: 'text', disabled: true },
    { hdata: translateObject('Expected'), tag: 'exp', datatype: 'text', disabled: true },
    { hdata: translateObject('Maximum'), tag: 'max', datatype: 'number', disabled: true }
  ];
  const sizing_h2_props = [
    { hdata: '', tag: 'title', datatype: 'text', disabled: true },
    { hdata: '', tag: 'unit', datatype: '', disabled: true },
    { hdata: '', tag: 'val', datatype: 'number', disabled: true }
  ];
  const system_params_props = [
    { hdata: '', tag: 'parameter', datatype: 'text', disabled: true },
    { hdata: translateObject('Value'), tag: 'val', datatype: '', disabled: true },
    { hdata: translateObject('Range'), tag: 'range', datatype: '', disabled: true },
    { hdata: translateObject('Status'), tag: 'status', datatype: '', disabled: true },
  ];
  const getEDIName = () => {
    let ediName = '';
    const local = localStorage.getItem(ediDetails.id);
    if (local) {
      ediName = ` - ${local}`;
    } else {
      ediName = ` - EDI ${Number(get(ediDetails, 'id', '').split('_')[1]) + 1}`;
    }
    // currentSelectedEDI = ediName.split('-')[1].trim();
    return ediName;
  };
  const getEdiDictKey = (val) => {
    let edi_dict_value = '';
    const edi_dict_keys = Object.keys(dbTransactionDetails.edi_dict).map(Number);
    edi_dict_keys.map((ele) => {
      if (dbTransactionDetails.edi_dict[ele].StackModel === val) {
        edi_dict_value = ele;
      }
    });
    return edi_dict_value;
  };
  const defaultpressusre = () => {
    let current_pressure_unit = units.pressure;
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units'))))
      current_pressure_unit = JSON.parse(localStorage.getItem('system-units')).pressure;
    setUstreamPip(parseFloat(convertUnitValues_pressure(upstream_pip, 'atm', current_pressure_unit)));
  };
  const submitForm = (closeForm = true) => {
    if (stackModel === '') {
      document.querySelector('#stackmodel fieldset').classList.add('error');
      document.querySelector('#tarres').classList.remove('error');
      document.querySelector('#flowstack').classList.remove('error');
      document.querySelector('#targetsilica fieldset').classList.remove('error');
      document.querySelector('#upstream_pipining').classList.remove('error');
    } else {
      if (target_resistivity === 0) {
        document.querySelector('#tarres').classList.add('error');
      }
      if (flow_per_stack === 0) {
        document.querySelector('#flowstack').classList.add('error');
      }
      if (rectifier_efficiency < 40 || rectifier_efficiency > 95) {
        document.querySelector('#recteff').classList.add('error');
      }
      if (!silicaDisable && targetsilica === '') {
        document.querySelector('#targetsilica fieldset').classList.add('error');
      }
      if (upstream_pip < 0 && !upstream_pip) {
        document.querySelector('#upstream_pipining').classList.add('error');
      }
    }
    if (stackModel === '' || (!upstream_pip && upstream_pip < 0) || ustreamRes === true || target_resistivity === 0 || flow_per_stack === 0 || dcoutput === 0 || (!silicaDisable && targetsilica === '')) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Please enter the required fields'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      return false;
    } else if (validateflow === true || validaterectEff === true || targetres === true) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Please enter the values within range'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
      return false;
    } else {
      const m3PerSec = 'm3/s';
      const pressure_unit = 'atm';
      const upstream_pip_updated = convertUnitValues_pressure(parseFloat(upstream_pip), units.pressure, pressure_unit);
      const flow_per_stack_updated = convertUnitValues_flow(parseFloat(flow_per_stack), units.flow, m3PerSec);
      const localdata = JSON.parse(localStorage.getItem('edi-dict'));
      const inputState = {
        'Feed': [1], 'Waste': [], 'Product': [2], 'Electrode Bleed': [3], 'Conc Bleed': [4], 'Unit Type': 'EDI',
        'name': `EDI ${Number(get(ediDetails, 'id', '').split('_')[1]) + 1}`,
        'flowperstack': flow_per_stack_updated,
        'upstrm_piping_press': Number(upstream_pip_updated),
        'rect_eff': Number(rectifier_efficiency), 'model_type': stackModel, 'rect_dc_volt': Number(dcoutput),
        'target_resistivity': Number(target_resistivity), 'target_silica': (targetsilica === 'None') ? 'None' : Number(targetsilica),
        'explosion_limit_h2': Number(explolimitH2), 'h2_design_sf': Number(safefactH2),
        'exposure_limit_cl2': Number(expolimitCl2), 'cl2_design_sf': Number(safefactCl2),
        'co_current': defaultCheck,
        'ro_edi_machine_model': get(localdata, `EDI.${ediDetails.id}.ro_edi_machine_model`, ''),
        'org_flowperstack': get(localdata, `EDI.${ediDetails.id}.org_flowperstack`, ''),
        ...(stackModel === 'MK-9' && { selected_recovery: selectedRecovery })
      };
      saveFormDataInLocalStorage({ record: inputState, type: 'EDI', id: ediDetails.id, item: 'edi-dict' });
      if (closeForm) {
        handleCloseEDI();
      }
      getBorderColor(ediDetails.id);
      setokbuttonFormAutoSave(true);
      if (isShowErrorMessage) {
        localStorage.setItem('globalExitBtn', 'true');
      }
      return true;
    }
  };
  const calculateFlowSheet = (str) => {
    const flag = submitForm(false);
    if (flag) {
      // changeEDIFormDataFlag = true;
      setTimeout(() => {
        setInputOutputFlag(false);
        document.getElementById(`${str}_data`).click();
      }, 0);
    }
  };

  function fetchOutputData() {
    if (localStorage.getItem('edi-output-dict')) {
      const outputdata = get(JSON.parse(localStorage.getItem('edi-output-dict')), `EDI.${ediDetails.id}`, {});
      const resdata = outputdata.output_user;
      if (!isEmpty(resdata)) {
        const systemparams = resdata.system_param;
        const feedwateranalysis = resdata.feed_water;
        const feedparams = resdata.feed_param;
        const calcparam = resdata.calc_param;
        const electrodegasgen = resdata.electrode_gas_gen;
        // System Parameters
        let keys = Object.keys(systemparams);
        for (let i = 0; i < output_dataCopy.system_param.length; i += 1) {
          for (let j = 0; j < keys.length; j += 1) {
            if (output_dataCopy.system_param[i].key === keys[j]) {
              if (systemparams[keys[j]] === 'None') {
                output_dataCopy.system_param[i].val = 'None';
              } else {
                output_dataCopy.system_param[i].val = Number(systemparams[keys[j]]).toFixed(2);
                output_dataCopy.system_param[i].range = systemparams[`${keys[j]}_range`];
                output_dataCopy.system_param[i].status = systemparams[`${keys[j]}_status`];
              }
              break;
            }
          }
        }
        // Feed Water Parameters
        keys = Object.keys(feedparams);
        for (let i = 0; i < output_dataCopy.feed_param.length; i += 1) {
          for (let j = 0; j < keys.length; j += 1) {
            if (output_dataCopy.feed_param[i].key === keys[j]) {
              output_dataCopy.feed_param[i].val = Number(feedparams[keys[j]]).toFixed(2);
              output_dataCopy.feed_param[i].range = feedparams[`${keys[j]}_range`];
              output_dataCopy.feed_param[i].status = feedparams[`${keys[j]}_status`];
              break;
            }
          }
        }
        // Feed Water Analysis
        keys = Object.keys(feedwateranalysis);
        for (let i = 0; i < output_dataCopy.feed_water.length; i += 1) {
          for (let j = 0; j < keys.length; j += 1) {
            if (output_dataCopy.feed_water[i].ion === keys[j]) {
              output_dataCopy.feed_water[i].val = Number(feedwateranalysis[keys[j]]).toFixed(3);
              break;
            }
          }
        }
        // Calculated Output Parameters
        keys = Object.keys(calcparam);
        let flow_unit = units.flow;
        let press_unit = units.pressure;
        let power_unit = units.power;
        if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
          flow_unit = JSON.parse(localStorage.getItem('system-units')).flow;
          press_unit = JSON.parse(localStorage.getItem('system-units')).pressure;
          power_unit = JSON.parse(localStorage.getItem('system-units')).power;
        }
        for (let i = 0; i < output_dataCopy.calc_param.length; i += 1) {
          for (let j = 0; j < keys.length; j += 1) {
            if (output_dataCopy.calc_param[i].key === keys[j]) {
              if (output_dataCopy.calc_param[i].key === 'acenergy' && ['gpm', 'gph', 'gps', 'gpd'].indexOf(flow_unit) >= 0)
                output_dataCopy.calc_param[i].parameter = 'AC Energy (KWh / 1000gal)';
              if (output_dataCopy.calc_param[i].key === 'product_flow_rate')
                output_dataCopy.calc_param[i].parameter = `Product Flow Rate (${flow_unit})`;
              if (output_dataCopy.calc_param[i].key === 'feed_inlet')
                output_dataCopy.calc_param[i].parameter = `Feed Inlet (${flow_unit})`;
              if (output_dataCopy.calc_param[i].key === 'concentrate_bleed')
                output_dataCopy.calc_param[i].parameter = `Concentrate Bleed (${flow_unit})`;
              if (output_dataCopy.calc_param[i].key === 'electrode_bleed')
                output_dataCopy.calc_param[i].parameter = `Electrode Bleed (${flow_unit})`;
              if (output_dataCopy.calc_param[i].key === 'feed_pressure')
                output_dataCopy.calc_param[i].parameter = `Feed Pressure (${press_unit})`;
              if (output_dataCopy.calc_param[i].key === 'pred_pdt_outlet_pressure')
                output_dataCopy.calc_param[i].parameter = `Predicted Product outlet pressure (${press_unit})`;
              if (output_dataCopy.calc_param[i].key === 'dcpower')
                output_dataCopy.calc_param[i].parameter = `DC power (${power_unit})`;
              if (output_dataCopy.calc_param[i].key === 'acpower')
                output_dataCopy.calc_param[i].parameter = `AC Power Consumption (${power_unit})`;
              // added for selected_recovery key matching to dispaly the value in Calculated Output Parameters coming from payload
              if (output_dataCopy.calc_param[i].key === 'selected_recovery' && stackModel === 'MK-9') {
                output_dataCopy.calc_param[i].parameter = 'Selected Recovery (%)';
              }
              if (output_dataCopy.calc_param[i].key === 'num_stacks') {
                output_dataCopy.calc_param[i].val = Math.floor(Number(calcparam[keys[j]]));
              }
              else if (calcparam[keys[j]] === 'NA') {
                output_dataCopy.calc_param[i].val = 'NA';
              } else if (calcparam[keys[j]] === 'N/A') {
                output_dataCopy.calc_param[i].val = 'N/A';
              }
              else {
                const calcparam_val = calcparam[keys[j]];
                if (output_dataCopy.calc_param[i].decimalVal === 0) {
                  output_dataCopy.calc_param[i].val = Number(calcparam_val).toFixed(0);
                } else if (output_dataCopy.calc_param[i].decimalVal > 0) {
                  output_dataCopy.calc_param[i].val = Number(calcparam_val).toFixed(output_dataCopy.calc_param[i].decimalVal);
                } else {
                  output_dataCopy.calc_param[i].val = Number(calcparam_val).toFixed(2);
                }
              }
              break;
            }
          }
        }
        // Electrode Gas Generation
        keys = Object.keys(electrodegasgen);
        for (let i = 0; i < keys.length; i += 1) {
          if (keys[i] === 'h2_expected')
            output_dataCopy.electrode_gas_gen[0].exp = electrodegasgen[keys[i]];
          else if (keys[i] === 'h2_max')
            output_dataCopy.electrode_gas_gen[0].max = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_expected')
            output_dataCopy.electrode_gas_gen[1].exp = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_max')
            output_dataCopy.electrode_gas_gen[1].max = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_exp_kg')
            output_dataCopy.electrode_gas_gen[2].exp = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_max_kg')
            output_dataCopy.electrode_gas_gen[2].max = electrodegasgen[keys[i]];
          else if (keys[i] === 'h2_explosion_limit')
            output_dataCopy.sizing_for_h2[0].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'h2_design_sf')
            output_dataCopy.sizing_for_h2[1].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'fan_size_h2_cmh')
            output_dataCopy.sizing_for_h2[2].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'fan_size_h2_cfm')
            output_dataCopy.sizing_for_h2[3].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_exposure_limit')
            output_dataCopy.sizing_for_cl2[0].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'cl2_design_sf')
            output_dataCopy.sizing_for_cl2[1].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'fan_size_cl2_cmh')
            output_dataCopy.sizing_for_cl2[2].val = electrodegasgen[keys[i]];
          else if (keys[i] === 'fan_size_cl2_cfm')
            output_dataCopy.sizing_for_cl2[3].val = electrodegasgen[keys[i]];
        }
      }
    }
  }
  const handleClose_EDI = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseEDI();
  };

  const handleCloseEDIModal = () => {
    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Are you sure you want to close this form?'),
        onYes: () => handleClose_EDI(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      handleCloseEDI();
    };
  };
  const clearForm = () => {
    setStackModel('');
    setFlowPerStack(0);
    defaultpressusre();
    setTargetResistivity(0);
    setTargetSilica('');
    setSelectedRecovery(0);
    setRectifierEfficiency(70);
    setRoEDIModelName('');
    setSilicaDisabled(true);
    setTargetres(false);
    setUstreamRes(false);
    setValidateFlow(false);
    setValidateRectEff(false);
    setDCOutput(0);
    setDisabled(true);
  };
  const ediFactSheets = (val) => {
    setDownloadUrl('');
    // Changed to read all EDI document URLs from env configuration.
    const edi_dict_value = getEdiDictKey(val);
    if (edi_dict_value === 1) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FS1622EN);
    } else if (edi_dict_value === 2) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSEL_E_CELL_MK_5STACK_EN);
    } else if (edi_dict_value === 3) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSEL_MK_7STACK_EN);
    } else if (edi_dict_value === 4) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSEL_MK_9STACK_EN);
    } else if (edi_dict_value === 5) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSPWE_CELLMK_3PHARMHT_EN);
    } else if (edi_dict_value === 6 || edi_dict_value === 7) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSPWE_CELLMK_3MINIHT_EN);
    } else if (edi_dict_value === 8) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSELECEL_EDI_MK_5D_STACK_EN);
    } else if (edi_dict_value === 9) {
      setDownloadUrl(process.env.REACT_APP_DOCUMENT_DOWNLOAD_URL_FSELECEL_EDI_MK_9D_STACK_EN);
    }
  };
  function handleChange(e, str) {
    // set the default value is 0 flow range and target Resistivity.
    /**
     * 1 -> MK-3
     * 2 -> MK-5
     * 3 -> MK-7
     * 4 -> MK-9
     * 5 -> MK-3 PharmHT
     * 6 -> MK-3 MiniHT Pharm
     * 7 -> MK-3 MiniHT Industrial
     * 8 -> MK-5D
     * 9 -> MK-9D
     */
    let resRangeVal = 0;
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    ediFactSheets(e.target.value);
    if (e.target.value !== '') {
      if (document.querySelector('#stackmodel fieldset'))
        document.querySelector('#stackmodel fieldset').classList.remove('error');
      setStackModel(e.target.value);
      const range = { min: 0, max: 0 };
      const edi_dict_value = getEdiDictKey(e.target.value);
      if ([1, 2, 3, 4, 7, 8, 9].indexOf(edi_dict_value) >= 0) {
        setSilicaDisabled(false);
        setResRange({ min: 1, max: 16 });
        // update the target Resistivity with max value
        resRangeVal = 16;
      }
      if ([5, 6].indexOf(edi_dict_value) >= 0) {
        setResRange({ min: 1, max: 10 });
        // update the target Resistivity with max value
        resRangeVal = 10;
        setSilicaDisabled(true);
      }
      if ([2, 3, 4, 8, 9].indexOf(edi_dict_value) >= 0) {
        setDCOutput(400);
        if (edi_dict_value === 2) {
          range.min = 10; range.max = 28;
        }
        if (edi_dict_value === 3) {
          range.min = 18.5; range.max = 34.3;
        }
        if (edi_dict_value === 4) {
          range.min = 18.5; range.max = 44.0;
        }
        if (edi_dict_value === 8) { // 8 equal to MK-5D
          range.min = 20; range.max = 68.6;
        }
        if (edi_dict_value === 9) {  // 9 equal to MK-9D
          range.min = 37; range.max = 88;
        }
      }
      if (edi_dict_value === 1) {
        range.min = 7.0; range.max = 20.0;
        setDCOutput(300);
      }
      if (edi_dict_value === 5) {
        range.min = 7.0; range.max = 23.8;
        setDCOutput(300);
      }
      if ([6, 7].indexOf(edi_dict_value) >= 0) {
        range.min = 2.2; range.max = 7.0;
        setDCOutput(150);
      }
      let flow_unit = units.flow;
      if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
        const previous_flow_unit = 'gpm';
        flow_unit = JSON.parse(localStorage.getItem('system-units')).flow;
        setFlowRange({
          min: parseFloat(convertUnitValues_flow(range.min, previous_flow_unit, flow_unit).toFixed(1)),
          max: parseFloat(convertUnitValues_flow(range.max, previous_flow_unit, flow_unit).toFixed(1))
        });
      } else {
        setFlowRange(range);
      }
      if (!str) {
        setTargetResistivity(resRangeVal);
        setFlowPerStack(0);
        setTargetSilica('');
        setRectifierEfficiency(70);
        setRoEDIModelName('');
        setDisabled(false);
        setTargetres(false);
        setUstreamRes(false);
        setValidateFlow(false);
        setValidateRectEff(false);
      }
    } else {
      if (document.querySelector('#stackmodel fieldset')) {
        document.querySelector('#stackmodel fieldset').classList.add('error');
        document.querySelector('#tarres').classList.remove('error');
        document.querySelector('#flowstack').classList.remove('error');
        document.querySelector('#recteff').classList.remove('error');
        document.querySelector('#targetsilica fieldset').classList.remove('error');
      }
      clearForm();
    }
  }
  function handleFormChange(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    setTargetSilica(e.target.value);
    document.querySelector('#targetsilica fieldset').classList.remove('error');
  }
  function handleFormChangeRecovery(e) {
    setSelectedRecovery(e.target.value);
  }
  function changeRectEff(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    if (e.target.value >= 40 && e.target.value <= 95) {
      setValidateRectEff(false);
      setRectifierEfficiency(e.target.value);
      e.target.classList.remove('error');
    } else {
      e.preventDefault();
      setValidateRectEff(true);
      e.target.classList.add('error');
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: 'Rectifier Eficiency must be between 40 and 95',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  }

  function handleIOButtons(e) {
    if (e.target.value === 'design') {
      setActiveForm(e.target.value);
      $('.edi-input-form').css('display', 'inline-block');
      $('.edi-output-form').css('display', 'none');
      $('.edi-guide').css('display', 'none');
    }
    if (e.target.value === 'ventilationsizing') {
      setActiveForm(e.target.value);
      $('.edi-input-form').css('display', 'none');
      $('.edi-output-form').css('display', 'flex');
      $('.edi-guide').css('display', 'none');
    }
    if (e.target.value === 'guide') {
      setActiveForm(e.target.value);
      $('.edi-guide').css('display', 'block');
      $('.edi-input-form').css('display', 'none');
      $('.edi-output-form').css('display', 'none');
    }
  }
  function handleGuideButtons(e) {
    setShowImg(e.target.value);
  }
  const inputValidation = (e, str) => {
    const val = e.target.value;
    const regex = /^[0-9]*\.?[0-9]*$/;
    if (regex.test(val)) {
      if (str === 'flow_per_stack') {
        setFlowPerStack(val);
      } else if (str === 'target_resistivity') {
        setTargetResistivity(val);
      } else if (str === 'rectifier_efficiency') {
        setRectifierEfficiency(val);
      } else if (str === 'upstream_pip') {
        setUstreamPip(val);
      }
    }
  };

  function changeTargetResistivity(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    if (e.target.value >= resRange.min && e.target.value <= resRange.max) {
      setTargetResistivity(e.target.value);
      setTargetres(false);
      e.target.classList.remove('error');
    } else {
      e.target.blur();
      e.target.classList.add('error');
      setTargetres(true);
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: `Target Resistivity must be between ${resRange.min} and ${resRange.max}`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  }
  const upstreamPipingPressure = (e) => {
    setIsShowErrorMessage(true);
    e.target.classList.remove('error');
    setUstreamRes(false);
    if (!e.target.value) {
      e.target.classList.add('error');
      setUstreamRes(true);
    }
    localStorage.setItem('globalExitBtn', 'true');
    setUstreamPip(e.target.value);
  };
  function changeFlowStack(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');
    let flow_unit = units.flow;
    if (!isEmpty(JSON.parse(localStorage.getItem('system-units'))))
      flow_unit = JSON.parse(localStorage.getItem('system-units')).flow;
    if (e.target.value >= flowRange.min && e.target.value <= flowRange.max) {
      setValidateFlow(false);
      setFlowPerStack(e.target.value);
      e.target.classList.remove('error');
    } else {
      e.preventDefault();
      setValidateFlow(true);
      e.target.classList.add('error');
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: `Flow per Stack must be between ${Math.round(flowRange.min * 10) / 10} ${flow_unit} and ${flowRange.max} ${flow_unit}`,
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  }
  const seletedRecoveryOption = () => {
    // Get stored EDI output data from localStorage
    const edi_output_dict = JSON.parse(localStorage.getItem('edi-output-dict'));
    // Get the first available key from the EDI object
    const firstKey = Object.keys(edi_output_dict?.EDI || {})[0];
    // Extract the selected recovery list from the nested payload
    const recoveryList = edi_output_dict?.EDI?.[firstKey]?.output_user?.calc_param?.calculated_selected_recovery_list;
    // Return the recovery list if it is a valid array, otherwise return an empty array
    // Example output: [92, 91, 87, 89, 90]
    const recoveryval = Array.isArray(recoveryList) ? recoveryList : [];
    return recoveryval;
  };
  function fetchFormDatafromLocalStorage(localdata, modelsArr = []) {
    /**
     * 1 -> MK-3
     * 2 -> MK-5
     * 3 -> MK-7
     * 4 -> MK-9
     * 5 -> MK-3 PharmHT
     * 6 -> MK-3 MiniHT Pharm
     * 7 -> MK-3 MiniHT Industrial
     * 8 -> MK-5D
     * 9 -> MK-9D
     */
    if (localdata.EDI[ediDetails.id]) {
      const data = localdata.EDI[ediDetails.id];
      const range = { min: 0, max: 0 };
      if (data.model_type === 'E-Cell-3X') {
        data.model_type = 'MK-5';
      }
      setStackModel(data.model_type);
      const edi_dict_value = getEdiDictKey(data.model_type);
      if ([1, 2, 3, 4, 7, 8, 9].indexOf(edi_dict_value) >= 0) {
        setSilicaDisabled(false);
        setResRange({ min: 1, max: 16 });
      }
      if ([5, 6].indexOf(edi_dict_value) >= 0) {
        setResRange({ min: 1, max: 10 });
        setSilicaDisabled(true);
      }
      if ([2, 3, 4, 8, 9].indexOf(edi_dict_value) >= 0) {
        if (edi_dict_value === 2) {
          range.min = 0.0006309; range.max = 0.001767;
        }
        if (edi_dict_value === 3) {
          range.min = 0.001136; range.max = 0.002164;
        }
        if (edi_dict_value === 4) {
          range.min = 0.0011666667; range.max = 0.00277778;
        }
        if (edi_dict_value === 8) { // 36 equal to MK-5D
          range.min = 0.001261803928069; range.max = 0.004327987473276;
        }
        if (edi_dict_value === 9) { // 35 equal to MK-9D
          range.min = 0.002334337266927; range.max = 0.005551937283503;
        }
        setDCOutput(400);
      }
      if (edi_dict_value === 1 || edi_dict_value === 5) {
        range.min = 0.00047318; range.max = 0.001262;
        setDCOutput(300);
      }
      if ([6, 7].indexOf(edi_dict_value) >= 0) {
        range.min = 0.00015773; range.max = 0.0004227;
        setDCOutput(150);
      }
      let current_flow_unit = units.flow;
      let current_pressure_unit = units.pressure;
      if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
        current_flow_unit = JSON.parse(localStorage.getItem('system-units')).flow;
        current_pressure_unit = JSON.parse(localStorage.getItem('system-units')).pressure;
      }
      const previous_flow_unit = 'm3/s';
      const decimalplace = current_flow_unit === 'gpm' ? 4 : 2;
      setFlowPerStack(parseFloat(convertUnitValues_flow(data.flowperstack, previous_flow_unit, current_flow_unit)).toFixed(decimalplace));
      setFlowRange({
        min: parseFloat(convertUnitValues_flow(range.min, previous_flow_unit, current_flow_unit).toFixed(2)),
        max: parseFloat(convertUnitValues_flow(range.max, previous_flow_unit, current_flow_unit).toFixed(2))
      });
      const previous_pressure_unit = 'atm';
      let pipingVal = 0.680;
      if (Number(data.upstrm_piping_press) >= 0) {
        pipingVal = Number(data.upstrm_piping_press);
      }
      setUstreamPip(parseFloat(convertUnitValues_pressure(pipingVal, previous_pressure_unit, current_pressure_unit)));
      setTargetResistivity(data.target_resistivity);
      setTargetSilica((data.target_silica === 'None') ? 'None' : data.target_silica);
      setRectifierEfficiency(data.rect_eff);
      setExploLimitH2(data.explosion_limit_h2);
      setSafeFactH2(data.h2_design_sf);
      setExpoLimitCl2(data.exposure_limit_cl2);
      setSafeFactCl2(data.cl2_design_sf);
      setDefaultCheck(data.co_current);
      setCoCurrent(data.co_current);
      setRoEDIModelName(data?.ro_edi_machine_model || '');
      setDisabled(false);
      setTargetres(false);
      setUstreamRes(false);
      setValidateFlow(false);
      setValidateRectEff(false);
      setSelectedRecovery(data.selected_recovery);
      // Get the available recovery options once
      const recoveryData = seletedRecoveryOption();
      // Check if there is already a selected recovery value
      const hasSelectedRecovery = !!data.selected_recovery;
      // Check if recovery options are available
      const hasRecoveryData = recoveryData.length > 0;
      // If a recovery is already selected but no options are returned,
      // use the selected recovery as the fallback option.
      // Otherwise, use the available recovery options.
      const options = hasSelectedRecovery && !hasRecoveryData ? [data.selected_recovery] : recoveryData;
      // Update the dropdown options
      setRecoveryOptions(options);
      // Disable the dropdown when no options are available
      setIsRecoveryDisabled(options.length === 0);
      if (data.model_type) {
        handleChange({ target: { value: data.model_type } }, 'currentRange');
        setIsShowErrorMessage(false);
        localStorage.setItem('globalExitBtn', 'false');
      }
      if (modelsArr.indexOf(data.model_type) === -1) {
        setStackModel('');
      }
    }
  }
  function updateExpolimitCl2(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    if (e.target.value < 0 || e.target.value > 100) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: 'Exposure limit of Cl2 must be between 0 and 100',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else {
      setExpoLimitCl2(e.target.value);
    }
  }
  function updateSafeFactH2(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    if (e.target.value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: 'Safety Factor must be positive',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else {
      setSafeFactH2(e.target.value);
    }
  }
  function updateSafeFactCl2(e) {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    if (e.target.value < 0) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: 'Safety Factor must be positive',
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
    else {
      setSafeFactCl2(e.target.value);
    }
  }
  useEffect(() => {
    const stackModelsdata = [];
    const models = Object.values(dbTransactionDetails.edi_dict);
    models.sort((a, b) => {
      return a.ParamId > b.ParamId ? 1 : -1;
    });
    const sortiongObj = {};
    models.forEach((ele) => {
      if (ele.PassCode === '0') {
        stackModelsdata.push(ele.StackModel);
      }
      sortiongObj[ele.ParamId] = ele;
    });
    dbTransactionDetails.edi_dict = sortiongObj;
    setStackModels(stackModelsdata);
    // replace the data to original data using JSON.parse(JSON.stringify(output_data));
    output_dataCopy = JSON.parse(JSON.stringify(originalOutputData));
    setsystem_params([...output_dataCopy.system_param]);
    setfeed_water_params([...output_dataCopy.feed_param]);
    setcalculated_params([...output_dataCopy.calc_param]);
    setelec_gas_gen([...output_dataCopy.electrode_gas_gen]);
    setsizing_h2([...output_dataCopy.sizing_for_h2]);
    setsizing_cl2([...output_dataCopy.sizing_for_cl2]);

    if (!isEmpty(JSON.parse(localStorage.getItem('system-units')))) {
      setUnits(JSON.parse(localStorage.getItem('system-units')));
    }
    if (localStorage.getItem('edi-dict')) {
      const localdata = JSON.parse(localStorage.getItem('edi-dict'));
      fetchFormDatafromLocalStorage(localdata, stackModelsdata);
    } else {
      defaultpressusre();
    }
    fetchOutputData();
  }, []);
  const chakedUncheckedInput = (e) => {
    setIsShowErrorMessage(true);
    localStorage.setItem('globalExitBtn', 'true');

    setDefaultCheck(e.target.checked);
    setCoCurrent(e.target.checked);
  };
  const edi_Schematic_view = () => {
    const c_data = [...calculated_params];
    const c_val = c_data.filter((d) => d.key === 'product_flow_rate')[0].val;
    if (c_val === 0 || c_val === '0.00') {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        yesOrNo: false,
        type: 'error',
        title: 'Error',
        message: 'EDI Schematic is not available.',
        onYes: () => setVisibleEDISchematic(true),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      setVisibleEDISchematic(true);
    }
  };
  const handleCloseEDISchematic = () => {
    setVisibleEDISchematic(false);
  };
  const getCalculateParamasData = (str) => {
    let data = [...calculated_params];
    if (str === 'less') {
      data = data.splice(0, Math.floor(data.length / 2));
    } else {
      data = data.splice(Math.floor(data.length / 2), data.length);
    }
    return data;
  };
  useEffect(() => {
    /**
     * previousaly call changeEDIFormData function onchange method after that add apply button in EDI
     * form so, after clicking on apply button data will be change in the EDI form so commnet below
     * line and add the new if condiotion when user click on apply button call fetchOutputData to
     *  update edi form
     *  */
    // if (inputOutputFlag && changeEDIFormDataFlag) {
    //   changeEDIFormDataFlag = false;
    //   changeEDIFormData();
    // }
    if (inputOutputFlag) {
      setTimeout(() => {
        fetchOutputData();
      }, 1000);
    }
  }, [inputOutputFlag]);

  return (
    <Modal
      hideBackdrop
      open={visibleEDI}
      onClose={handleCloseEDIModal}
      className='splitter-modal'
    >
      <Box className=''>
        <Rnd
          default={{
            width: '85%',
            x: ((window.innerWidth / 2) - ((85 * (window.innerWidth / 100)) / 2)),
            y: ((window.innerHeight / 2) - ((75 * (window.innerHeight / 100)) / 2)),
          }}
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '5px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='40%'
          cancel=".no_drag, .MuiOutlinedInput-root"
          resizeHandleClasses={{
            'left': 'left_string',
            'right': 'right_string'
          }}
          className='edi-box'>
          <Notification
            options={modalOption}
            handleClose={() => setModalOption(defaultModalOptions)}
          />
          <Grid container className='edi-grid-container edi-wrapper'>
            <Grid item xs={12} className='edi-header-grid'>
              <div className='edi-grid-title rufusBld no_drag S_heading'>{`EDI ${getEDIName()}`}</div>
              <div className='edi-grid-container no_drag'>
                <Tooltip title='Close'>
                  <img
                    src={closeIconBlack}
                    alt='close'
                    onClick={handleCloseEDIModal}
                    style={{ width: '14px', padding: '11px' }}
                    className='pointer'
                  />
                </Tooltip>
              </div>
            </Grid>
            <Grid item xs={12} className='edi-body-container sansW4SeLig'>
              <Grid item xs={12}>
                <div className='edi-iobuttons'>
                  <ToggleButtonGroup
                    color="primary"
                    value={activeform}
                    exclusive
                    onChange={(e) => { handleIOButtons(e); }}
                    style={{ display: 'block' }}
                  >
                    <ToggleButton value="design" className='sansW4SeLig M_Regular secoundary-text-color-Primary-default'>{translateObject('Design')}</ToggleButton>
                    <ToggleButton value="ventilationsizing" className='sansW4SeLig M_Regular secoundary-text-color-Primary-default'>{translateObject('Ventilation Sizing')}</ToggleButton>
                    <ToggleButton value="guide" className='sansW4SeLig M_Regular secoundary-text-color-Primary-default'>{translateObject('Feed Guarantee Guide')}</ToggleButton>
                  </ToggleButtonGroup>
                </div>
                <div className='edi-input-form' style={{ 'overflowY': 'auto' }}>
                  <Grid container item xs={12} spacing={1} className='output-top-container' style={{ marginTop: '0.5%' }}>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className='input-params' style={{ height: '100%' }}>
                        <div className='normal-font f-left rufusReg no_drag M_Bold' style={{ marginTop: '-7px', background: 'white', marginLeft: '10px', padding: '0 4px' }}>{translateObject('Input')}</div>
                        <div className='grid-container'>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular'>{translateObject('Stack Model')}</div>
                            <div className='edi-textbox fact-sheets-wrapper'>
                              <div id="stackmodel" className='edi-select' style={{ minWidth: '40%', width: 'inherit' }}>
                                <Select className='stackmodel' fullWidth style={{ fontSize: 12 }} value={stackModel} onChange={(e) => { handleChange(e); }}>
                                  <MenuItem value='' onClick={clearForm}>{translateObject('Select')}</MenuItem>
                                  {stackModels.map((names, ind) => {
                                    return (
                                      <MenuItem key={ind} value={names}>
                                        {names}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              </div>
                              {downloadUrl && (
                                <div className='fact-sheets S_Regular S_Bold'>
                                  <a href={downloadUrl} target='_blank' rel="noreferrer" download>{stackModel}</a>
                                  <span className='no_drag S_Regular'>{roEDIModelName}</span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular'>{translateObject('Target Resistivity')}</div>
                            <div className='edi-textbox' id="targetresistivity">
                              <input type='number' id='tarres' value={target_resistivity}
                                onBlur={(e) => { changeTargetResistivity(e); }}
                                onInput={(e) => { inputValidation(e, 'target_resistivity'); }}
                                onFocus={e => e.target.select()}
                                disabled={disabled} className='no_drag Form_Input_design' required />
                              <div className='no-drag-units Form_Input_design_Units no_drag ft12'>MΩ.cm {stackModel && `(${resRange.min} - ${resRange.max})`} </div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular'>{translateObject('Flow Per Stack')}</div>
                            <div className='edi-textbox' id="flowstackdata">
                              <input type='number' id='flowstack' value={flow_per_stack}
                                onFocus={e => e.target.select()}
                                onInput={(e) => { inputValidation(e, 'flow_per_stack'); }}
                                onBlur={(e) => { changeFlowStack(e); }}
                                disabled={disabled} className='no_drag Form_Input_design' required />
                              <div className='no-drag-units Form_Input_design_Units no_drag ft12 S_Regular'>{units.flow} {stackModel && `(${flowRange.min} - ${flowRange.max})`}</div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular'>{translateObject('Target Silica Gaurantee')}</div>
                            <div className='edi-textbox'>
                              <div className={`edi-select ${targetsilica}`} style={{ width: '100%' }} id="targetsilica">
                                <Select className='tarsil' fullWidth style={{ width: '78px', fontSize: 12 }} value={targetsilica} onChange={(e) => { handleFormChange(e); }}
                                  disabled={silicaDisable}>
                                  <MenuItem value='None'>{translateObject('No Silica Guarantee Requested')}</MenuItem>
                                  {targetSilicas.map((names, ind) => {
                                    return (<MenuItem key={ind}
                                      value={names}
                                    >
                                      {names}
                                    </MenuItem>);
                                  })}
                                </Select>
                                <div className='no-drag-units no_drag ft12 Form_Input_design_Units' style={{ marginLeft: 5 }}>ppb SiO<sub>2</sub></div>
                              </div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular' >{translateObject('Rectifier Efficiency')}</div>
                            <div className='edi-textbox' id="rectifierefficiency">
                              <input type='number' id='recteff' value={rectifier_efficiency}
                                onFocus={e => e.target.select()}
                                onInput={(e) => { inputValidation(e, 'rectifier_efficiency'); }}
                                onBlur={(e) => { changeRectEff(e); }} className='no_drag Form_Input_design' required disabled={disabled} />
                              <div className='no-drag-units no_drag ft12 Form_Input_design_Units'>% {stackModel && '(40 - 95)'}</div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular' >{translateObject('Rectifier DC Output')}</div>
                            <div className='edi-textbox' id="dcoutputdata">
                              <input type='number' id='dcoutput' value={dcoutput} className='no_drag Form_Input_design'
                                onFocus={e => e.target.select()}
                                required disabled={inputDisabled} />
                              <div className='no-drag-units no_drag ft12 Form_Input_design_Units'>Volts</div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular' style={{ width: '40%', position: 'relative' }}>
                              <span>{translateObject('Upstream Interconnecting Piping Pressure Loss')}</span>
                              <Tooltip title={translateObject('RO permeate pressure must be at least 0.34 bar | 5 psi higher than E-Cell feed pressure to account for pressure loss in piping between RO permeate and E-Cell feed')} placement="top" arrow>
                                <InfoOutlinedIcon style={{ fontSize: 14, paddingLeft: 2, position: 'absolute' }} />
                              </Tooltip>
                            </div>
                            <div className='edi-textbox' id="upstream_pipdata" style={{ marginTop: 10 }}>
                              <input type='number' id='upstream_pipining' value={upstream_pip}
                                onFocus={e => e.target.select()}
                                onInput={(e) => { inputValidation(e, 'upstream_pip'); }}
                                onBlur={(e) => { upstreamPipingPressure(e); }}
                                disabled={disabled} className='no_drag Form_Input_design' required />
                              <div className='no-drag-units Form_Input_design_Units no_drag ft12 S_Regular'>{units.pressure} {/* stackModel && `(${flowRange.min} - ${flowRange.max})` */}</div>
                            </div>
                          </div>
                          <div className='input-select-grid'>
                            <div className='normal-font f-left mt-2 no_drag S_Regular'>{translateObject('Co-Current')}</div>
                            <div className='edi-textbox' id="uncheckedinput">
                              <div className='edi-select' style={{ minWidth: '40%', width: 'inherit' }}>
                                <Checkbox className={defaultCheck ? 'check-box' : ''} checked={defaultCheck} onChange={chakedUncheckedInput} {...checkboxprop} />
                              </div>
                            </div>
                          </div>
                          {/* Add Selected Recovery dropDown */}
                          {(stackModel === 'MK-9') && (
                            <div className='input-select-grid'>
                              <div className='normal-font f-left mt-2 no_drag S_Regular'>Selected Recovery</div>
                              <div className='edi-textbox'>
                                <div className='edi-select' style={{ width: '100%' }} id="selectedrecovery">
                                  <Select
                                    className='tarsil'
                                    fullWidth
                                    style={{ width: '78px', fontSize: 12 }}
                                    value={selectedRecovery}
                                    onChange={(e) => handleFormChangeRecovery(e)}
                                    disabled={isRecoveryDisabled}
                                    displayEmpty
                                  >
                                    <MenuItem value=''>
                                      {isRecoveryDisabled ? 'NA' : 'Select'}
                                    </MenuItem>

                                    {recoveryOptions.map((val) => (
                                      <MenuItem key={val} value={val}>
                                        {val}
                                      </MenuItem>
                                    ))}
                                  </Select>

                                  <div className='no-drag-units no_drag ft12 Form_Input_design_Units' style={{ marginLeft: 5 }}>%</div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className='output-params calculated-output-parameters' style={{ height: '100%', position: 'relative' }}>
                        <div className='normal-font1 f-left rufusReg no_drag M_Bold'>{translateObject('Calculated Output Parameters')}</div>
                        <div className='output-params-container forground-text-primary' style={{ display: 'flex', marginTop: '2%', float: 'right' }}>
                          <Grid item xs={6} className='grid-container' style={{ maxHeight: '100%' }}>
                            <div className='calculated-left-content'>
                              <ul>
                                {getCalculateParamasData('less').length > 0 && getCalculateParamasData('less').map((ele, ind) => {
                                  if (ele.key === 'selected_recovery' && stackModel !== 'MK-9') {
                                    return '';
                                  }
                                  return (
                                    <li className='li-content' key={ind}>
                                      <span className='parameter no_drag S_Regular' dangerouslySetInnerHTML={{ __html: translateObject(ele.parameter) }} />
                                      <span className='val no_drag S_Regular'>{ele.val}</span>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </Grid>
                          <Grid item xs={6} className='grid-container' style={{ maxHeight: '100%' }}>
                            <div className='calculated-left-content'>
                              <ul>
                                {getCalculateParamasData('greater').length > 0 && getCalculateParamasData('greater').map((ele, ind) => {
                                  return (
                                    <li className='li-content' key={ind}>
                                      <span className='parameter no_drag S_Regular'>{translateObject(ele.parameter)}</span>
                                      <span className='val no_drag S_Regular'>{ele.val}</span>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          </Grid>
                        </div>
                        <Grid item xs={12} className='schematic-view' >
                          {visibleEDISchematic && (
                            <EDISchematicView
                              visibleEDISchematic={visibleEDISchematic}
                              handleCloseEDISchematic={handleCloseEDISchematic}
                              getEDIName={getEDIName}
                              cocurrent={cocurrent}
                              ediDetails={ediDetails}
                            />
                          )}
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12} spacing={1} className='output-top-container feedwater-output-parameters' style={{ marginTop: '0.5%', paddingBottom: '1%' }}>
                    <Grid item xs={12} sm={12} md={12} lg={6} className='feedwater-output-parameters_grid'>
                      <div className='output-params' style={{ 'height': '41.5vh' }}>
                        <div className='normal-font1 f-left rufusReg no_drag M_Bold'>{translateObject('Feedwater Parameters')}</div>
                        <div className='grid-container no_drag'>
                          <div className='fwparams'>
                            <UIGrid
                              data={feed_water_params}
                              properties={system_params_props}
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6}>
                      <div className='output-params' style={{ height: '41.5vh' }}>
                        <div className='normal-font1 f-left rufusReg no_drag M_Bold'>{translateObject('System Parameters')}</div>
                        <div className='grid-container no_drag'>
                          <div className='sparams'>
                            <UIGrid
                              data={system_params}
                              properties={system_params_props}
                            />
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className='edi-output-form' style={{ display: 'none', overflow: 'auto' }}>
                  <Grid container item xs={12}>
                    <Grid item xs={12} sm={12} md={12} lg={6} className='edi-output-form-left-Section' >
                      <div className='input-parameters'>
                        <div className='normal-font f-left rufusReg no_drag M_Bold' style={{ marginTop: '-7px', background: 'white', marginLeft: '20px', padding: '0 4px' }}>{translateObject('Input')}</div>
                        <table className='edi-output-table'>
                          <tbody>
                            <tr className='output-parameter'>
                              <td>
                                <div className='separator-container'>
                                  <span className='normal-font f-left rufusReg no_drag S_Bold' style={{ marginTop: '-8.5px', background: 'white' }}>
                                    {translateObject('Blower/Ventilation Sizing for H')}<sub>2</sub></span>
                                  <div className='input-select-grid'>
                                    <span className='normal-font f-left mt-2 no_drag S_Regular' style={{ fontWeight: 'normal' }} dangerouslySetInnerHTML={{ __html: translateObject('Explosion Limit of H2 in Air') }} />
                                    <div className='edi-textbox'>
                                      <input type='number' id='limitH2' value={explolimitH2} className='no_drag Form_Input_design'
                                        required
                                        onFocus={e => e.target.select()} disabled={inputDisabled} />
                                      <span className='no-drag-units no_drag Form_Input_design_Units'>%</span>
                                    </div>
                                  </div>
                                  <div className='input-select-grid'>
                                    <span className='normal-font f-left mt-2 no_drag S_Regular' style={{ fontWeight: 'normal' }}>{translateObject('Design Safety Factor')}</span>
                                    <div className='edi-textbox'>
                                      <input type='number' id='safefactH2' value={safefactH2} className='no_drag Form_Input_design'
                                        onFocus={e => e.target.select()}
                                        onChange={(e) => { updateSafeFactH2(e); }} required />
                                      <span className='no-drag-units no_drag Form_Input_design_Units'>%</span>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table className='edi-output-table'>
                          <tbody>
                            <tr className='output-parameter'>
                              <td>
                                <div className='separator-container container-right'>
                                  <span className='normal-font f-left rufusReg no_drag S_Bold' style={{ marginTop: '-8.5px', background: 'white' }}>
                                    {translateObject('Blower/Ventilation Sizing for Cl')}<sub>2</sub></span>
                                  <div className='input-select-grid'>
                                    <span className='normal-font f-left mt-2 no_drag S_Regular' style={{ fontWeight: 'normal' }} dangerouslySetInnerHTML={{ __html: translateObject('Exposure Limit of Cl2 in Air') }} />
                                    <div className='edi-textbox'>
                                      <input type='number' id='limitCl2' value={expolimitCl2} className='no_drag Form_Input_design'
                                        onFocus={e => e.target.select()}
                                        onChange={(e) => { updateExpolimitCl2(e); }} required />
                                      <div className='no-drag-units no_drag Form_Input_design_Units'>%</div>
                                    </div>
                                  </div>
                                  <div className='input-select-grid'>
                                    <span className='normal-font f-left mt-2 no_drag S_Regular' style={{ fontWeight: 'normal' }}>{translateObject('Design Safety Factor')}</span>
                                    <div className='edi-textbox'>
                                      <input type='number' id='safefactCl2' value={safefactCl2} className='no_drag Form_Input_design'
                                        onFocus={e => e.target.select()}
                                        onChange={(e) => { updateSafeFactCl2(e); }} required />
                                      <div className='no-drag-units no_drag Form_Input_design_Units'>%</div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={6} className='edi-output-form-right-Section'>
                      <div className='input-parameters'>
                        <div className='normal-font f-left rufusReg no_drag M_Bold' style={{ marginTop: '-7px', background: 'white', marginLeft: '20px', padding: '0 4px' }}>{translateObject('Output')}</div>
                        <div className='wrapper-sizing-electrode' style={{ maxHeight: '65vh' }}>
                          <div className='sizing-h2'>
                            <div className='normal-font sansW4SeLig f-left no_drag S_Bold' style={{ marginTop: '-8px', background: 'white' }}>
                              {translateObject('Blower/Ventilation Sizing for H')}<sub>2</sub></div>
                            <div className='grid-container no_drag' style={{ padding: '10px 0 0 0' }}>
                              <UIGrid
                                data={sizing_h2}
                                properties={sizing_h2_props}
                              />
                            </div>
                          </div>
                          <div className='sizing-cl2'>
                            <div className='normal-font sansW4SeLig f-left no_drag S_Bold' style={{ marginTop: '-8px', background: 'white' }}>
                              {translateObject('Blower/Ventilation Sizing for Cl')}<sub>2</sub></div>
                            <div className='grid-container no_drag' style={{ padding: '10px 0 0 0' }}>
                              <UIGrid
                                data={sizing_cl2}
                                properties={sizing_h2_props}
                              />
                            </div>
                          </div>
                          <div className='electrode-gas-gen'>
                            <div className='normal-font sansW4SeLig f-left no_drag S_Bold' style={{ marginTop: '-8px', background: 'white' }}>
                              {translateObject('Electrode Gas Generation')}</div>
                            <div className='grid-container no_drag' style={{ padding: '10px 0 0 0' }}>
                              <UIGrid
                                data={elec_gas_gen}
                                properties={elec_gas_gen_props}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className='edi-guide' style={{ display: 'none' }}>
                  <ToggleButtonGroup
                    color="primary"
                    value={showimg}
                    exclusive
                    onChange={(e) => { handleGuideButtons(e); }}
                  >
                    <ToggleButton value={feed_water} className='M_Regular secoundary-text-color-Primary-default' style={{ whiteSpace: 'nowrap', height: 0 }}>
                      {translateObject('Feed Water Specification')}
                    </ToggleButton>
                    <ToggleButton value={note} className='edi_pressedtab M_Regular secoundary-text-color-Primary-default' style={{ whiteSpace: 'nowrap', height: 0 }}>
                      {translateObject('Note')}
                    </ToggleButton>
                    <ToggleButton value={feed_tea} className='M_Regular secoundary-text-color-Primary-default' style={{ whiteSpace: 'nowrap', height: 0 }}>
                      {translateObject('Feed TEA Limitations for Resistivity Gaurantee')}
                    </ToggleButton>
                    <ToggleButton value={silica_3s} className='M_Regular secoundary-text-color-Primary-default' style={{ whiteSpace: 'nowrap', height: 0 }}>
                      {translateObject('Effluent Silica Gaurantee (3 Series)')}
                    </ToggleButton>
                    <ToggleButton value={silica_7s} className='M_Regular secoundary-text-color-Primary-default' style={{ whiteSpace: 'nowrap', height: 0 }}>
                      {translateObject('Effluent Silica Gaurantee (7 Series)')}
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Grid item xs={12} className='display-image-container' style={{ textAlign: 'center', 'overflow': 'overlay', padding: 20 }}>
                    <img style={{ width: '100%' }} src={showimg} className='no_drag' />
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className='edi-button'>
                  <Stack spacing={2} direction='row'>
                    <Button
                      size="small"
                      variant="contained"
                      className={`btn-auto-width apply_btn sansW4SeLig M_Bold ${!inputOutputFlag ? 'Primary-Disabled Forground-Text-Disabled' : 'backgroud-primary-default forground-text-primary-inverse'}`}
                      disabled={!inputOutputFlag}
                      onClick={() => { calculateFlowSheet('calculate'); }}
                      style={{ display: activeform === 'guide' ? 'none' : 'block' }}
                    >
                      {translateObject('Apply')}
                    </Button>
                    <Button
                      size="small"
                      variant="contained"
                      className={`btn-auto-width sansW4SeLig M_Bold ${!inputOutputFlag ? 'Primary-Disabled Forground-Text-Disabled' : 'backgroud-primary-default forground-text-primary-inverse'}`}
                      disabled={!inputOutputFlag}
                      onClick={edi_Schematic_view}
                      style={{ display: activeform === 'guide' ? 'none' : 'block' }}
                    >
                      {translateObject('EDI Schematic view')}
                    </Button>
                  </Stack>
                  <Stack spacing={2} direction='row'>
                    <Button variant='contained M_Bold Secondary-Default_button btn-auto-width' size='small' className=' sansW4SeLig'
                      style={{ border: 'none' }}
                      onClick={handleCloseEDIModal}> {translateObject('Cancel')} </Button>
                    <Button variant='contained M_Bold Primary_Default_Button btn-auto-width' size='small' className=' sansW4SeLig'
                      onClick={submitForm}> {translateObject('OK')} </Button>
                  </Stack>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default EDIInput;
